var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"config":_vm.config},on:{"input":function($event){return _vm.$emit('input', this.text)}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }